import type { ExchangeRateQueryPort } from "../ports/ExchangeRateQueryPort";

export class GetExchangeRateUseCase {
  constructor(private readonly exchangeRateQueryPort: ExchangeRateQueryPort) {}

  async execute(): Promise<number> {
    return this.exchangeRateQueryPort.getUsdRate();
  }
}
